export default "__VITE_ASSET__ClYca_ge__"